import React from "react";
export default ({ a_fill = "#F9A56B", b_fill = "#FFFFFF", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" {...props}>
    <circle fill={a_fill} cx="7" cy="7" r="7" />
    <rect x="4.3" y="3.5" fill={b_fill} width="2" height="7" />
    <rect x="7.7" y="3.5" fill={b_fill} width="2" height="7" />
  </svg>
);
